import type { BillingTier } from "schemas/generated/billing";

import { skipToken } from "@tanstack/react-query";
import { useCurrentWorkspaceId } from "@v2/contexts/WorkspaceDashboardContext";
import { subscriptionRouter } from "@v2/trpc/routes/subscription";
import { getBillingPlanInfoByTier } from "schemas/billing";

import useCurrentProjectId from "./useCurrentProjectId";

/**
 * get the current projects active subscription details (name, paymentProcessor,
 * startDate, monthlyAmount id, etc.)
 */
export function useSubscriptionDetails() {
  const workspaceId = useCurrentWorkspaceId();
  const projectId = useCurrentProjectId();

  const workspaceActiveSubscription =
    subscriptionRouter.getActiveSubscription.useQuery(
      workspaceId
        ? {
            workspaceId,
            projectId,
          }
        : skipToken,
    );

  return workspaceActiveSubscription;
}

export function useHasPaidSubscription() {
  const { data: subscriptionDetails } = useSubscriptionDetails();
  return Boolean(
    subscriptionDetails && subscriptionDetails.billingTier !== "free",
  );
}

/**
 * gets the current projects active subscription info (CTA, description,
 * features, plan limits etc.)
 */
export function useSubscriptionInfo() {
  const { data: subscriptionDetails, ...rest } = useSubscriptionDetails();

  return {
    ...rest,
    subscriptionInfo: getBillingPlanInfoByTier(
      subscriptionDetails?.billingTier ?? "free",
    ),
  };
}

export function useSubscriptionTier(): BillingTier {
  const { subscriptionInfo } = useSubscriptionInfo();
  return subscriptionInfo.tier ?? "free";
}
